module.exports = __webpack_public_path__ + "img/acidification-terrestrial.96780dc7.png";